import { RadioField, RadioInput } from '@flos/react-ui';
import WizardPagetemplate from '../../../../templates/WizardPagetemplate';
import { useRecoilState, useRecoilValue } from 'recoil';
import { allCoverablesOnsaAtom } from '../../../../recoil/atoms/allCoverablesOnsaAtom';
import { getOnsaCurrentProductSelector } from '../../../../recoil/selectors/getOnsaCurrentProductSelector';
import type { CoverableInformationToUpdateDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/onsa';
import { useSaveCoverableInformation } from '../../../../hooks/useSaveCoverableInformation';
import { getCoverableIndex } from '../../../../utils/coverablesUtil';
import { useState } from 'react';
import { useHippoText } from '../../../../hooks/useHippoText';
import CoverableDetailsTemplate from '../../../../templates/CoverableDetailsTemplate';
import ViewHippoInformationModal from '../../../../shared_components/ViewHippoInformationModal/ViewHippoInformationModal';
import { isRequestPendingAtom } from '../../../../recoil/atoms/isRequestPendingAtom';
import { track } from '../../../../utils/trackingUtil';
import { accountHolderAtom } from '../../../../recoil/atoms/accountHolderAtom';
import { useUpdateCoverableInformation } from '../../../../recoil/hooks/useUpdateCoverableInformation';
import HelpLink from '../../../../shared_components/HelpLink/HelpLink';

const TravelInsuranceTypeStep = ({ goNext }: { goNext: () => void }): React.JSX.Element => {
    const getHippoText = useHippoText();
    const { saveCoverableInformation } = useSaveCoverableInformation();
    const isRequestPending = useRecoilValue(isRequestPendingAtom);
    const [coverables] = useRecoilState(allCoverablesOnsaAtom);
    const currentProduct = useRecoilValue(getOnsaCurrentProductSelector);
    const accountHolderData = useRecoilValue(accountHolderAtom);
    const { travels = [] } = coverables;
    const coverableIndex = getCoverableIndex(travels, currentProduct.fixedId);
    const coverable = travels[coverableIndex];
    const { insuranceType } = coverable;
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [showModal, setShowModal] = useState<boolean>(false);
    const [flavourName, setFlavourName] = useState<string>(coverable.insuranceType);
    const { updateCoverableInformation } = useUpdateCoverableInformation();

    const onNext = (): void => {
        setIsLoading(true);
        updateCoverableInformation({
            name:
                flavourName === 'top_tra_household'
                    ? 'Hele husstanden'
                    : accountHolderData.firstName,
            insuranceType: flavourName
        });
        const updatedCoverable: CoverableInformationToUpdateDTO = {
            travel: {
                publicId: coverable.publicId,
                fixedId: coverable.fixedId,
                insuranceType: flavourName ?? ''
            },
            productToUpdate: currentProduct.flavourName
        };
        void saveCoverableInformation(updatedCoverable).then(() => {
            track(`${coverable.flavourName}CoverableInformationInsuranceType`, [
                {
                    insuranceType: flavourName
                }
            ]);
            setIsLoading(false);
            goNext();
        });
    };

    return (
        <WizardPagetemplate
            onNext={onNext}
            hidePrevious
            disableNext={!insuranceType || isLoading || isRequestPending}
            isNextLoading={isLoading || isRequestPending}
        >
            <CoverableDetailsTemplate
                header={getHippoText('DSS-COVERABLE-INFORMATION-STEP-ADDRESS-HEADER')}
            >
                <RadioField
                    value={flavourName}
                    onChange={(event) => {
                        if (isLoading || isRequestPending) return;
                        setFlavourName(event.target.value);
                    }}
                    stacked={false}
                    required
                    disabled={isLoading || isRequestPending}
                >
                    <RadioInput
                        value="top_tra_individual"
                        label={getHippoText('DSS-COVERABLE-INFORMATION-STEP-ADDRESS-ONE-PERSON')}
                    />
                    <RadioInput
                        value="top_tra_household"
                        label={getHippoText(
                            'DSS-COVERABLE-INFORMATION-STEP-ADDRESS-MULTIPLE-PEOPLE'
                        )}
                    />
                </RadioField>
                <HelpLink
                    onClick={() => {
                        setShowModal(true);
                    }}
                >
                    {getHippoText(
                        'DSS-COVERABLE-INFORMATION-STEP-ADDRESS-WHEN-IS-A-PERSON-A-PERMANENT-RESIDENT'
                    )}
                </HelpLink>
            </CoverableDetailsTemplate>
            {showModal && (
                <ViewHippoInformationModal
                    closeModal={() => {
                        setShowModal(false);
                    }}
                    modalProps={{
                        title: 'DSS-TRAVEL-COVERABLE-INFO-STEP-MODAL-HEADER',
                        description: 'DSS-TRAVEL-COVERABLE-INFO-STEP-MODAL-DESCRIPTION'
                    }}
                    showModal={showModal}
                />
            )}
        </WizardPagetemplate>
    );
};

export default TravelInsuranceTypeStep;
